import styles from "../../../styles/service/product-details.module.scss";
import classNames from "classnames/bind";

import { QuestionItem } from "./QuestionItem";
import { Checkbox } from "@components";
import { Currency } from "shared/utils/Currency";

const css = classNames.bind(styles);

export const prepareProduct = (product) => {
  if ((product.sizes || []).filter((s) => s.selected).length === 0) {
    product.sizes[0].selected = true;
  }
  product.selected = true;
  return product;
};

export const buildSteps = (product) => {
  const steps = [];

  if ((product.sizes || []).length > 1) {
    steps.push({ id: "sizes", name: "Tamanho", min: 1 });
  }

  const addQuestionSteps = (items) => {
    (items || []).forEach((question) => {
      if (!question.ref_id || !Array.isArray(question.items)) return;
      steps.push({
        id: question.ref_id,
        name: question.name,
        min: question.min,
      });
      (question.items || []).forEach((option) => {
        if (option.selected) addQuestionSteps(option.items);
      });
    });
  };

  addQuestionSteps(product.items);

  if ((product.extra_ingredients || []).length > 0) {
    steps.push({ id: "extras", name: "Ingredientes extras", min: 0 });
  }

  return steps;
};

export const findQuestion = (items, refId) => {
  for (const item of items || []) {
    if (item.ref_id === refId) return item;
    const found = findQuestion(item.items, refId);
    if (found) return found;
  }
  return null;
};

export const updateQuestionInItems = (items, refId, updatedQuestion) => {
  return (items || []).map((item) => {
    if (item.ref_id === refId) return updatedQuestion;
    if (item.items) {
      return {
        ...item,
        items: updateQuestionInItems(item.items, refId, updatedQuestion),
      };
    }
    return item;
  });
};

export default function Step({ localProduct, activeStep, onProductChange }) {
  const renderSizesSection = () => (
    <>
      <div className={styles.sectionHeader}>
        <p className={styles.title}>Tamanho</p>
        <span className={styles.selectQuantity}>Selecione 1</span>
      </div>
      <div className={styles.options}>
        {localProduct.sizes.map((size, sizeIndex) => (
          <div
            key={sizeIndex}
            className={css({ option: true, selected: size.selected })}
            onClick={() => {
              localProduct.sizes.forEach((s) => (s.selected = false));
              localProduct.sizes[sizeIndex].selected = true;
              onProductChange({ sizes: localProduct.sizes });
            }}
          >
            <div className="d-flex flex-column">
              <p className={styles.name}>{size.name}</p>
              <div className="d-flex align-center gap-5">
                <span className={styles.price}>
                  {Currency.formatCurrency(size.price)}
                </span>
                {size.promo_price && (
                  <strike className={styles.fromPrice}>
                    {Currency.formatCurrency(size.old_price)}
                  </strike>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  const renderActiveQuestion = () => {
    const question = findQuestion(localProduct.items, activeStep);
    if (!question) return null;

    return (
      <QuestionItem
        question={question}
        onChange={(updatedQuestion) => {
          const newItems = updateQuestionInItems(
            localProduct.items,
            activeStep,
            updatedQuestion,
          );
          onProductChange({ items: newItems });
        }}
        onCompletedQuestion={() => {}}
      />
    );
  };

  const renderExtrasSection = () => {
    const currentSize = localProduct.sizes.find((s) => s.selected);
    const extras = localProduct.extra_ingredients.map((extra) => {
      const extraSize = extra.sizes?.find(
        (size) => size.ref_id === currentSize?.ref_id,
      );
      return {
        ...extra,
        sku: extraSize?.sku || extra.sku,
        price: extraSize?.price || extra.price,
        originalPrice: extraSize?.originalPrice || extra.originalPrice,
      };
    });

    return (
      <>
        <div className={styles.sectionHeader}>
          <p className={styles.title}>Ingredientes extras</p>
        </div>
        <div className={styles.options}>
          {extras.map((e, eIndex) => (
            <div
              className={styles.option}
              key={eIndex}
              onClick={() => {
                extras[eIndex].selected = !extras[eIndex].selected;
                onProductChange({ extra_ingredients: extras });
              }}
            >
              <div className="d-flex flex-column">
                <p className={styles.name}>{e.name}</p>
                <div className="d-flex align-center mt-10">
                  <span className={styles.price}>
                    {Currency.formatCurrency(e.price)}
                  </span>
                </div>
              </div>
              <Checkbox
                value={e.name}
                checked={e.selected}
                key={`extraingredient-${e.id}`}
              />
            </div>
          ))}
        </div>
      </>
    );
  };

  if (!localProduct || !activeStep) return null;

  return (
    <>
      {activeStep === "sizes" && renderSizesSection()}
      {activeStep !== "sizes" &&
        activeStep !== "extras" &&
        renderActiveQuestion()}
      {activeStep === "extras" && renderExtrasSection()}
    </>
  );
}
